import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isUndefined } from 'lodash';
import { loadNotes } from 'actions';
import { getLoaders, getNotesQuestionnaireId } from 'selectors';
import { LoadingSpinner } from 'components/helpers/LoadingSpinner';
import QuestionNotesContainer from './QuestionNotesContainer';


class QuestionNotesModal extends React.Component {
  static propTypes = {
    asqQuestionId: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isData: PropTypes.object,
    hasNotes: PropTypes.bool.isRequired,
    qNumber: PropTypes.number.isRequired,
    params: PropTypes.object.isRequired,
    loadNotes: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { params, asqQuestionId } = this.props;
    this.props.loadNotes(params, {source: 'init'}, {asq_question_id: asqQuestionId});
  }

  render() {
    const { hasNotes, isData, isLoading, asqQuestionId, qNumber, params } = this.props;
    if (hasNotes && (isLoading || isUndefined(isData))) {
      return (
        <div className='column u-margin-top--base u-margin-bottom--base'>
          <LoadingSpinner />
        </div>
      );
    }
    return (
      <div>
        <QuestionNotesContainer asqQuestionId={asqQuestionId} qNumber={qNumber} params={params} />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    asqQuestionId: ownProps.asqQuestionId,
    isLoading: getLoaders(state, ['WEBNOTES']),
    isData: get(state.modal.meta, `entities.questions[${ownProps.asqQuestionId}]`),
    hasNotes: ownProps.hasNotes,
    params: {
      asqQuestionId: ownProps.asqQuestionId,
      playerId: get(state.player, 'player.id', 0),
      playerQuestionnaireId: getNotesQuestionnaireId(state),
    },
    qNumber: ownProps.qNumber,
  }
}

export default connect(mapStateToProps, { loadNotes })(QuestionNotesModal);
